<div class="filter-container" [formGroup]="formGroup" [hidden]="!showFilter">
    <div class="row">
        <div class="col-md-10">
            <div class="row padding-bottom-15">
                <div class="col-md-6">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <label class="input-group-text" for="filter">
                                <i class="fa fa-search fa-2x" aria-hidden="true"></i>
                            </label>
                        </div>
                        <input type="text" #filter autocomplete="off" class="form-control" id="filter" formControlName="filter" [placeholder]="(('Component' | terminology | async) || 'Component') + ' Name /  GL Code / Cost Center / Project'" [attr.aria-label]="(('Component' | terminology | async) || 'Component') + ' Name /  GL Code / Cost Center / Project'" aria-describedby="button-search">
                        <div class="input-group-append">
                            <label class="input-group-text" for="filter" *ngIf="filter.value" (click)="clearFilter()">
                                <i class="fa fa-times-circle fa-2x" aria-hidden="true"></i>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <select class="sp-select form-control" formControlName="activityType">
                        <option value="">-- All Activity Types --</option>
                        <option value="Component">{{ 'Components' | terminology | async }}</option>
                        <option value="File">{{ 'Component' | terminology | async }} Files</option>
                        <option value="Note">{{ 'Component' | terminology | async }} Notes</option>
                        <option value="Photo">{{ 'Component' | terminology | async }} Photos</option>
                        <option value="ComponentDescription">{{ 'Component' | terminology | async }} Description</option>
                        <option value="Project">Projects</option>
                        <option value="ProjectFile">Project Files</option>
                        <option value="ProjectNote">Project Notes</option>
                        <option value="ProjectPayment">Project Payments</option>
                        <option value="ProjectPhoto">Project Photos</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <select class="sp-select form-control" formControlName="userId">
                        <option value="">-- All Users --</option>
                        <option *ngFor="let user of activityReport?.users" [ngValue]="user.userId">{{user.firstName}} {{user.lastName}}</option>
                    </select>
                </div>
            </div>

            <div class="row padding-bottom-15">
                <div class="col-md-4">
                    <select class="sp-select form-control" formControlName="category">
                        <option value="">-- All Categories --</option>
                        <option *ngFor="let category of activityReport?.propertyComponentCategories" [ngValue]="category.propertyComponentCategoryId">{{category.name}}</option>
                    </select>
                </div>
                <div class="col-md-3" *ngIf="activityReport?.projects?.length > 0">
                    <select class="sp-select form-control" formControlName="category">
                        <option value="">-- All Projects --</option>
                        <option *ngFor="let project of activityReport?.projects" [ngValue]="project.projectId">{{project.name}}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <select class="sp-select form-control" formControlName="dateRange" #dateRange>
                        <option value="">-- All Dates --</option>
                        <option [value]="constants.CurrentMonth">Current Month</option>
                        <option [value]="constants.PreviousMonth">Previous Month</option>
                        <option [value]="constants.CurrentYear">Current Year</option>
                        <option [value]="constants.PreviousYear">Previous Year</option>
                        <option [value]="constants.CustomDateRange">Custom Date Range</option>
                    </select>
                </div>
            </div>

            <div class="row padding-bottom-15" [hidden]="dateRange.value !== 'CustomDateRange'">
                <div class="col-md-4 form-group">
                    <dx-date-range-box
                           placeholder="Select Dates"                           
                           formControlName="customDateRange"
                           displayFormat="MM/dd/yyyy"
                           applyValueMode="useButtons"
                           labelMode="outside"
                           [openOnFieldClick]="true">
                    </dx-date-range-box>
                </div>
            </div>
        </div>
        <div class="col-md-2 text-end">
            <button type="button" class="btn btn-icon" (click)="onFiltersReset()" title="Reset All Filters"><i aria-hidden="true" class="fa fa-eraser fa-2x"></i></button>
            <button type="button" class="btn btn-icon" (click)="onHideFilter()" title="Hide Filter"><i aria-hidden="true" class="fa fa-times fa-2x"></i></button>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">

        <table class="report-data margin-top-10">
            <tr class="report-grid-header">
                <th><span>Activity</span></th>
                <th><span>User</span></th>
                <th><span>Date</span></th>
            </tr>

            <ng-container *ngFor="let activity of activityReport?.activitiesPaged.data">
                <!--https://stackoverflow.com/questions/46225020/is-there-a-way-to-declare-a-specific-type-in-ngfor-->
                <tr class="report-grid-row">
                    <td>
                        <a [routerLink]="" (click)="onViewActivityDetails(activity)">{{activity['entityName']}}</a>
                        <div>{{activity['description']}}</div>
                    </td>
                    <td class="no-wrap">{{ activity['userName'] }}</td>
                    <td class="no-wrap">{{ activity['date'] | date: 'shortDate'}} at {{ activity['date'] | date: 'shortTime' }}</td>
                </tr>
            </ng-container>
        </table>
        
        <!-- DevExtreme Pagination (new) -->
        <div class="dx-pagination-left">
            <dx-pagination
                [itemCount]="activityReport?.page?.totalItems || 0"
                [pageSize]="20"
                [showPageSizeSelector]="false"
                [showInfo]="true"
                [showNavigationButtons]="true"
                (onOptionChanged)="onDxPageChanged($event)">
            </dx-pagination>
        </div>
    </div>
</div>
